import { Component, Inject, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicantService } from 'app/laas/applicant.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UntypedFormBuilder, UntypedFormGroup, Validators, } from '@angular/forms';
import { AdminAuthService } from 'app/admin/admin-auth.service';

@Component({
  selector: 'wl-consent-otp-dialog',
  template: `
  <h3>Verify OTP:</h3>
  <form novalidate [formGroup]="otpForm">

  <wl-input type="text" label="OTP" placeholder="Enter Otp" formControlName="otpCode"></wl-input>

  <mat-progress-bar *ngIf="isOtpVerifying"  mode="buffer"></mat-progress-bar>

  <div style="display:flex;flex-direction:row;justify-content:center;align-items:center;">
    <wl-button style="flex:1 1 30%;" (click)="closeDialog()">Close</wl-button>
    <wl-button style="flex:1 1 30%;" (click)="resend()" >Resend</wl-button>
    <wl-button style="flex:1 1 30%;" [disabled]="!otpForm.valid" (click)="verify(otpForm.value)">Verify</wl-button>
  </div>
  
  </form>
  `,
  providers:[ApplicantService]

})

export class ConsentOtpDialogComponent {

  otpForm: UntypedFormGroup;
  otp: any;
  isOtpVerifying: boolean;
  custId: any;
  password: any;
  company: any;
  roleId: any;

  constructor(
    private fb: UntypedFormBuilder,
    private snackbar: MatSnackBar,
    public dialogRef: MatDialogRef<ConsentOtpDialogComponent>,
    private adminAuth: AdminAuthService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private admin: AdminAuthService,
    private applicant: ApplicantService
  ) {
    this.otpForm = this.fb.group({
      otpCode: ['', Validators.required]
    })
    this.custId = data.custId;

    this.sendOtp(this.custId);
  }

  sendOtp(val) {
    this.isOtpVerifying = true;
    console.log("otp ", val.otpCode);
    this.otp = val.otpCode;
    // val.mobile = this.mobile;
    // val.roleId = this.roleId;
    // this.admin.verifyOtp(this.mobile,this.otp,this.roleId).subscribe(resp => {
    this.applicant.consentOtp(this.custId).subscribe(resp => {

      this.isOtpVerifying = false;
      // if (resp) {
      //   this.dialogRef.close(resp);
      // } else {
      //   this.dialogRef.close(false);
      // }
    })
  }

  resend(){
    this.sendOtp(this.custId);
    this.snackbar.open('OTP has been sent again to your mobile number', 'OK', { duration: 3000 })

  }


  verify(val){
    this.applicant.verifyConsentOtp(this.custId,val).subscribe(resp=>{
      if(resp && resp.success){
        this.dialogRef.close(resp);
      }else {
          this.dialogRef.close(resp);
        }
    })
  }

  closeDialog() {
    this.isOtpVerifying = false;
    this.dialogRef.close(false);
  }
  // resend() {
  //   this.adminAuth.adminLogin(this.custId, this.otp).subscribe(resp => {
  //     console.log("resent ", resp);
  //     if (resp && resp.success) {
  //       this.snackbar.open('OTP has been sent again to your mobile number', 'OK', { duration: 3000 })
  //     } else {
  //       this.snackbar.open(resp.message, 'OK', { duration: 3000 })
  //     }
  //   })
  // }
}


@Component({
  selector: "wl-loanrenewal-yes-no",
  templateUrl: "./loanrenewal-yes-no.component.html",
  styles: [],
  providers: [ApplicantService],
})
export class LoanrenewalYesNoComponent implements OnInit {

  byebye: boolean;
  consentPending: boolean;
  applicantId: any;
  custId:any;

  constructor(
    private router: Router,
    private applicant: ApplicantService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    let urlvalue = window.location.href;
    this.applicantId = urlvalue.split("/")[(urlvalue.split("/").length) - 1];
    console.log("applicantId", this.applicantId);
    this.applicant.getConsentStatus(this.applicantId).subscribe((resp) => {
      console.log("getConsentStatus", resp);
      if(resp && resp.result && resp.result.custId){
        this.custId = resp.result.custId;
      }
      if (resp && resp.message == "success") {
        this.consentPending = true;
      } else {
        document.getElementById('ConsentText').innerText = resp.message;
      }
    })

  }

  confirmrenewal() {
    var dialogRef: MatDialogRef<ConsentOtpDialogComponent>;
    // let urlvalue = window.location.href;
    // let applicantId = urlvalue.split("/")[urlvalue.length-1];
    // const payload = {
    //   applicantId:this.applicantId,
    //   ack_status: "yes",
    // };
    // this.applicant.consentyesornoForm(payload).subscribe((resp) => {
    //   console.log("resp " + JSON.stringify(resp));
    //   // this.router.navigate([`/loanrenewal_web/${applicantId}`]);
    // });

    dialogRef = this.dialog.open(ConsentOtpDialogComponent, {
      disableClose: true,
      height: 'auto', width: 'auto',
      data: {

        custId:this.custId
      }
    });

    dialogRef.afterClosed().subscribe(res => {
      console.log("res " + JSON.stringify(res));
      if (res && res.success) {
        this.snackbar.open(res.message, 'OK', { duration: 3000 })

        const payload = {
            applicantId:this.applicantId,
            ack_status: "yes",
          };
          this.applicant.consentyesornoForm(payload).subscribe((resp) => {
            console.log("resp " + JSON.stringify(resp));
            // this.router.navigate([`/loanrenewal_web/${applicantId}`]);
          });
          this.router.navigate([`loanrenewal_web/${this.applicantId}`]);
      } else {
        this.snackbar.open("Cancelled", 'OK', { duration: 3000 })
      }
    })
  }

  confirmreject() {

    const payload = {
      applicantId: this.applicantId,
      ack_status: "no",
    };
    this.applicant.consentyesornoForm(payload).subscribe((resp) => {
      console.log("resp " + JSON.stringify(resp));
      if (!resp.success && resp.message == "Feedback status no") {
        this.snackbar.open('Thank you for visiting the page', 'OK', { duration: 3000 });
      } else {
        // this.snackbar.open('Something Went wrong', 'OK', { duration: 3000 });
      }
    });
    this.byebye = true;
    this.consentPending = false;

  }

  openDialogWithTemplateRef(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef);
  }
}
